module.exports = __webpack_public_path__ + "img/antes_despues_126.7cbd41f9.png";